import React from 'react';
import isEqual from 'lodash/isEqual';

import CountryIdField from './CountryIdField';
import { Select } from '@framework/ui/Organisms/FinalForm/Fields/Select';
import { Field } from '@framework/ui/Organisms/FinalForm';

import { useCallFormContext } from '../../CallFormContext';
import { useDialInCountriesTableContext } from '../DialInCountriesTableContext';

import { DIAL_IN_COUNTRY_FOR_OPTIONS_ARRAY } from '../constants';
import { IDialInCountryTableRowItem } from '../interfaces';
import { getDialInCountriesTableSelectLayoutProps } from '../helpers';
import { CallFormInstance } from '../../interfaces';

import styles from '../dialInCountriesTable.module.scss';

interface IProps {
  row: IDialInCountryTableRowItem,
}

const CountryForCell = (
  {
    row,
  }: IProps,
) => {
  const {
    disabled,
  } = useDialInCountriesTableContext();
  const { instance } = useCallFormContext();
  return (
    <>
      <div className={ styles.countryInputMobileContainer }>
        <CountryIdField
          isMobile
          row={ row }
        />
      </div>
      <Field
        { ...getDialInCountriesTableSelectLayoutProps(isEqual(instance, CallFormInstance.ScheduleYourCall)) }
        isClearable={ false }
        name={ `${ row.fieldName }.countryFor` }
        placeholder="Select Country"
        // @ts-ignore
        component={ Select }
        options={ DIAL_IN_COUNTRY_FOR_OPTIONS_ARRAY }
        dataTest="countryFor"
        isDisabled={ disabled }
        isNarrow
      />
    </>
  );
};

export default CountryForCell;
